var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"r-on-off-list-box",class:[
    {
      'on': _vm.value === 1,
      'off': _vm.value === 2,
      'is-readonly': _vm.readonly,
      'is-disabled': _vm.disabled
    }
  ],attrs:{"disabled":_vm.disabled || _vm.readonly,"autocomplete":"off"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.model=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.handleChange]}},[_c('option',{domProps:{"value":1}},[_vm._v("○")]),_vm._v(" "),_c('option',{domProps:{"value":2}},[_vm._v("×")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6f701aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/r-elements/ROnOffListBox.vue
// module id = null
// module chunks = 